import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { PageHeader, FormField } from '../../components/UI';
import toast from 'react-hot-toast';

export default function SystemSettings() {
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings').then(r => setSettings(r.settings||{}));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/settings', { settings });
      toast.success('System settings saved!');
    } catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  const f = (k,v) => setSettings(p=>({...p,[k]:v}));

  return (
    <div className="max-w-3xl">
      <PageHeader title="⚙️ System Settings" subtitle="Configure core system parameters" />
      <form onSubmit={handleSave} className="space-y-6">
        {/* General */}
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">General Settings</h3>
          <div className="space-y-4">
            <FormField label="Support Email">
              <input type="email" className="form-input" value={settings.support_email||''} onChange={e=>f('support_email',e.target.value)} />
            </FormField>
            <FormField label="Support Phone">
              <input className="form-input" value={settings.support_phone||''} onChange={e=>f('support_phone',e.target.value)} />
            </FormField>
            <FormField label="Application URL">
              <input className="form-input" value={settings.app_url||''} onChange={e=>f('app_url',e.target.value)} placeholder="https://govnoc.gov.in" />
            </FormField>
          </div>
        </div>

        {/* OTP Settings */}
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">OTP Settings</h3>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Default OTP (Dev Only)">
              <input className="form-input" value={settings.default_otp||''} onChange={e=>f('default_otp',e.target.value)} maxLength={6} />
            </FormField>
            <FormField label="OTP Expiry (Minutes)">
              <input type="number" className="form-input" value={settings.otp_expiry_minutes||10} onChange={e=>f('otp_expiry_minutes',e.target.value)} />
            </FormField>
          </div>
        </div>

        {/* File Upload Settings */}
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">File Upload Settings</h3>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Max File Size (MB)">
              <input type="number" className="form-input" value={settings.max_upload_size_mb||10} onChange={e=>f('max_upload_size_mb',e.target.value)} />
            </FormField>
            <FormField label="Allowed File Types">
              <input className="form-input" value={settings.allowed_file_types||''} onChange={e=>f('allowed_file_types',e.target.value)} placeholder="pdf,jpg,jpeg,png,doc,docx" />
            </FormField>
          </div>
        </div>

        {/* SMS Settings */}
        <div className="card">
          <h3 className="font-semibold text-gray-800 mb-4">SMS Gateway Settings</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <FormField label="SMS Enabled">
              <select className="form-select" value={settings.sms_enabled||'0'} onChange={e=>f('sms_enabled',e.target.value)}>
                <option value="0">Disabled (Mock)</option>
                <option value="1">Enabled</option>
              </select>
            </FormField>
            <FormField label="SMS Sender ID">
              <input className="form-input" value={settings.sms_sender_id||''} onChange={e=>f('sms_sender_id',e.target.value)} placeholder="GOVNOC" />
            </FormField>
          </div>
          <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-xs text-yellow-700">
            ⚠️ SMS Gateway URL and API Key must be configured in the server .env file. Enable here only after configuring server-side credentials.
          </div>
        </div>

        <button type="submit" className="btn-primary px-8 py-3" disabled={saving}>
          {saving ? 'Saving...' : '💾 Save System Settings'}
        </button>
      </form>
    </div>
  );
}
